import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Admissions from "./pages/Admissions";
import ProgramOfStudy from "./pages/ProgramOfStudy";
import OurPeople from "./pages/OurPeople";
import FAQ from "./pages/FAQ";
import Announcements from "./pages/Announcements";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import NavBar from "./components/NavBar";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* <Route path="/overview" element={<Overview />} /> */}
      <Route path="/admissions" element={<Admissions />} />
      <Route path="/program-of-study" element={<ProgramOfStudy />} />
      <Route path="/our-people" element={<OurPeople />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/announcements" element={<Announcements />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <NavBar />
      <AppRoutes />
      <ScrollToTop />
    </BrowserRouter>
  </AuthProvider>
);

export default App;
